import { createSlice } from "@reduxjs/toolkit";
import { GET_VendorDashboard, PATCH_VendorDashboardData, GET_RFQbyID } from "./thunk";

const VendorDashboard = createSlice({
  name: "VendorDashboard",
  initialState: {
    data: null,
    loading: false,
    error: null,
    success: false,
    patchData: null,
    patchDataLoading: false,
    patchDataError: null,
    patchDataSuccess: false,
    rfqData: null,           // New state for RFQbyID
    rfqLoading: false,
    rfqError: null,
    rfqSuccess: false
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
      state.success = false;
      state.patchData = null;
      state.patchDataLoading = false;
      state.patchDataSuccess = false;
      state.patchDataError = null;
      state.rfqData = null;        // Reset RFQ data
      state.rfqLoading = false;
      state.rfqSuccess = false;
      state.rfqError = null;
    },
    updateStatus: (state)=>{
      state.patchDataLoading=false;
      state.patchDataError=null;
      state.patchDataSuccess=false;
    },
  },

 
  extraReducers: (builder) => {
    builder
      // For Get VendorDashboardData
      .addCase(GET_VendorDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(GET_VendorDashboard.fulfilled, (state, action) => {
        state.success = true;
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(GET_VendorDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // For Patch VendorData
      .addCase(PATCH_VendorDashboardData.pending, (state) => {
        state.patchDataLoading = true;
        state.patchDataError = null;
        state.patchDataSuccess = false;
      })
      .addCase(PATCH_VendorDashboardData.fulfilled, (state, action) => {
        state.patchDataSuccess = true;
        state.patchData = action.payload;
        state.patchDataLoading = false;
      })
      .addCase(PATCH_VendorDashboardData.rejected, (state, action) => {
        state.patchDataLoading = false;
        state.patchDataError = action.payload;
      })

      // For Get RFQbyID
      .addCase(GET_RFQbyID.pending, (state) => {
        state.rfqLoading = true;
        state.rfqError = null;
        state.rfqSuccess = false;
      })
      .addCase(GET_RFQbyID.fulfilled, (state, action) => {
        state.rfqSuccess = true;
        state.rfqData = action.payload;
        console.log(action.payload);
        
        state.rfqLoading = false;
      })
      .addCase(GET_RFQbyID.rejected, (state, action) => {
        state.rfqLoading = false;
        state.rfqError = action.payload;
      });
  },
});

export const { resetState,updateStatus } = VendorDashboard.actions;
export default VendorDashboard.reducer;
